import {  Grid, Typography } from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import React, { useEffect } from 'react'
import { getUser, getUserId } from '../Utils/Common';
import Home from './Home'

// import LinearProgress from '@mui/material/LinearProgress';
import { Col, Row } from 'react-bootstrap';
import BillingReportsService from '../../Services/Reports/BillingReportsService';
import { useState } from 'react';
import OperationReportService from '../../Services/Reports/OperationReportService';


// function LinearProgressWithLabel(props) {
//   return (
//     <Box sx={{ display: 'flex', alignItems: 'center' }}>
//       <Box sx={{ width: '100%', mr: 1 }}>
//         <LinearProgress variant="determinate" color='secondary' {...props} />
//       </Box>
//       <Box sx={{ minWidth: 35 }}>
//         <Typography variant="body2" color="text.secondary">{`${Math.round(
//           props.value,
//         )}%`}</Typography>
//       </Box>
//     </Box>
//   );
// }

export const useDate = () => {
  const locale = 'en';
  const [today, setDate] = React.useState(new Date()); // Save the current date to be able to trigger an update

  React.useEffect(() => {
    const timer = setInterval(() => { // Creates an interval which will update the current data every minute
      // This will trigger a rerender every component that uses the useDate hook.
      setDate(new Date());
    }, 10000);
    return () => {
      clearInterval(timer); // Return a funtion to clear the timer so that it will stop being called on unmount
    }
  }, []);

  const day = today.toLocaleDateString(locale, { weekday: 'short' });
  const date = `${day}, ${today.getDate()} ${today.toLocaleDateString(locale, { month: 'short' })}\n\n`;

  const hour = today.getHours();
  const wish = `Good ${(hour < 12 && 'Morning') || (hour < 15 && 'Afternoon') || 'Evening'}`;

  const time = today.toLocaleTimeString(locale, { hour: 'numeric', hour12: true, minute: 'numeric', second: 'numeric' });

  return {
    date,
    time,
    wish,
  };
};


function DashBoard() {

  // const [totalimport, settotalimport] = useState([])
  // const [totalexport, settotalexport] = useState([])
  // const [totalbilling, settotalbilling] = useState([])
  // const [billingamt, setbillingamt] = useState([])
  const [values, setvalues] = useState([])
  const [values2, setvalues2] = useState([])
  const [values3, setvalues3] = useState([])
  // const [radiovalue, setradiovalue] = useState('')

  const [amount, setamount] = useState({
    totaljobamt: '',
    totalvendoramt: '',
    totalmiscamt: '',
  })
  var today = new Date();

  // Getting full month name (e.g. "June")
  var month = today.toLocaleString('default', { month: 'long' });

  const { wish } = useDate();

  const importjob = () => {
    window.open("http://35.154.221.117:8081/Scope_Imports/")
  }

  const ExportJob = () => {
    window.open("http://45.118.160.218:8081/scope_export/")
  }


  const arrowicon = () => {
    return <ArrowForwardIosIcon />
  }
  const gettotalimportjobs = () => {
    BillingReportsService.getDashboardDetails(getUserId(), 1).then(res => {
      const details = res.data;
      const datas = details.map(trns => trns)
      setvalues(datas[0].total_import_jobs)
    })
  }
  const gettotalexportjobs = () => {
    BillingReportsService.getDashboardDetails(getUserId(), 2).then(res => {
      const details = res.data;
      const datas = details.map(trns => trns)
      setvalues2(datas[0].total_export_jobs)
    })
  }
  const gettotalbilledjobs = () => {
    BillingReportsService.getDashboardDetails(getUserId(), 3).then(res => {
      const details = res.data;
      const datas = details.map(trns => trns)
      setvalues3(datas[0].total_billed_jobs)
    })
  }
  const getamt = () => {
    BillingReportsService.getDashboardDetails(getUserId(), 4).then(res => {
      const details = res.data;
      const datas = details.map(trns => trns)
      if(!datas[0]){
        setamount({ ...amount, totaljobamt: 0, totalvendoramt: 0, totalmiscamt: 0 })
      }else{
        setamount({ ...amount, totaljobamt: datas[0].job_amt, totalvendoramt: datas[0].vendor_amt, totalmiscamt: datas[0].misc_amt })
      }
      
    })
  }
  const exceljob = () => {
    getDashboardReport(5)
  }
  const excelmisc = () => {
    getDashboardReport(6)
  }
  const excelvendor = () => {
    getDashboardReport(7)
  }

  const getDashboardReport = (val) => {
    BillingReportsService.getdashboardReport(getUserId(), val).then(res => {
      const data = res.data
      const details2 = data.map((trns) => trns)
      var tableContent2 = "", contenall2 = '';

      for (let i = 0; i < details2.length; i++) {
        if (details2[i].payments_id !== '') {
          tableContent2 += details2[i].payments_id + "!"
        } else {
          tableContent2 += "!"
        } if (details2[i].fund_request_type !== '') {
          tableContent2 += details2[i].fund_request_type + "!"
        } else {
          tableContent2 += "!"
        }
        if (details2[i].consignmentIds !== '') {
          tableContent2 += details2[i].consignmentIds + "!"
        } else {
          tableContent2 += "!"
        }
        if (details2[i].request_purpose !== '') {
          tableContent2 += details2[i].request_purpose + "!"
        } else {
          tableContent2 += "!"
        }
        if (details2[i].request_amount !== '') {
          tableContent2 += details2[i].request_amount + "!"
        } else {
          tableContent2 += "!"
        }
        if (details2[i].approval_amount !== '') {
          tableContent2 += details2[i].approval_amount + "!"
        } else {
          tableContent2 += "!"
        }
        if (details2[i].first_level_amount !== '') {
          tableContent2 += details2[i].first_level_amount + "!"
        } else {
          tableContent2 += "!"
        }
        if (details2[i].second_level_amount !== '') {
          tableContent2 += details2[i].second_level_amount + "!"
        } else {
          tableContent2 += "!"
        }
        if (details2[i].allocated_amount !== '') {
          tableContent2 += details2[i].allocated_amount + "!"
        } else {
          tableContent2 += "!"
        }
        if (details2[i].release_amount !== '') {
          tableContent2 += details2[i].release_amount + "!"
        } else {
          tableContent2 += "!"
        }
        if (details2[i].release_mode !== '') {
          tableContent2 += details2[i].release_mode + "!"
        } else {
          tableContent2 += "!"
        }
        if (details2[i].audit_amount !== '') {
          tableContent2 += details2[i].audit_amount + "!"
        } else {
          tableContent2 += "!"
        }
        if (details2[i].request_date !== '') {
          tableContent2 += details2[i].request_date + "!"
        } else {
          tableContent2 += "!"
        }
        if (details2[i].approval_date !== '') {
          tableContent2 += details2[i].approval_date + "!"
        } else {
          tableContent2 += "!"
        }
        if (details2[i].first_level_date !== '') {
          tableContent2 += details2[i].first_level_date + "!"
        } else {
          tableContent2 += "!"
        }
        if (details2[i].second_level_date !== '') {
          tableContent2 += details2[i].second_level_date + "!"
        } else {
          tableContent2 += "!"
        }
        if (details2[i].allocated_date !== '') {
          tableContent2 += details2[i].allocated_date + "!"
        } else {
          tableContent2 += "!"
        }
        if (details2[i].release_date !== '') {
          tableContent2 += details2[i].release_date + "!"
        } else {
          tableContent2 += "!"
        }
        if (details2[i].audit_date !== '') {
          tableContent2 += details2[i].audit_date + "!"
        } else {
          tableContent2 += "!"
        }
        if (details2[i].request_remarks !== '') {
          tableContent2 += details2[i].request_remarks + "!"
        } else {
          tableContent2 += "!"
        }
        if (details2[i].approval_remarks !== '') {
          tableContent2 += details2[i].approval_remarks + "!"
        } else {
          tableContent2 += "!"
        }
        if (details2[i].first_level_remarks !== '') {
          tableContent2 += details2[i].first_level_remarks + "!"
        } else {
          tableContent2 += "!"
        }
        if (details2[i].second_level_remarks !== '') {
          tableContent2 += details2[i].second_level_remarks + "!"
        } else {
          tableContent2 += "!"
        }
        if (details2[i].allocated_remarks !== '') {
          tableContent2 += details2[i].allocated_remarks + "!"
        } else {
          tableContent2 += "!"
        }
        if (details2[i].release_remarks !== '') {
          tableContent2 += details2[i].release_remarks + "!"
        } else {
          tableContent2 += "!"
        }
        if (details2[i].audit_remarks !== '') {
          tableContent2 += details2[i].audit_remarks + "!"
        } else {
          tableContent2 += "!"
        }
        if (details2[i].req_by !== '') {
          tableContent2 += details2[i].req_by + "!"
        } else {
          tableContent2 += "!"
        }
        if (details2[i].approved_by !== '') {
          tableContent2 += details2[i].approved_by + "!"
        } else {
          tableContent2 += "!"
        }
        if (details2[i].first_level_by !== '') {
          tableContent2 += details2[i].first_level_by + "!"
        } else {
          tableContent2 += "!"
        }
        if (details2[i].second_level_by !== '') {
          tableContent2 += details2[i].second_level_by + "!"
        } else {
          tableContent2 += "!"
        }
        if (details2[i].allocated_by !== '') {
          tableContent2 += details2[i].allocated_by + "!"
        } else {
          tableContent2 += "!"
        }
        if (details2[i].released_by !== '') {
          tableContent2 += details2[i].released_by + "!"
        } else {
          tableContent2 += "!"
        }
        if (details2[i].audit_by !== '') {
          tableContent2 += details2[i].audit_by + "!"
        } else {
          tableContent2 += "!"
        }
        if (details2[i].status !== '') {
          tableContent2 += details2[i].status + "#"
        } else {
          tableContent2 += "  #"
        }
      }
      contenall2 = tableContent2;
      let details = {
        headerName2: "3,0,ACCOUNT DETAILS REPORT", headerDetails2: "",
        tableHeader2: "0,3,Sl.No/1,3,Payments_id/2,3,Fund Request Type/3,3,consignmentId/4,3,Request Purpose/5,3,Request Amount/6,3,Approval Amount/7,3,Firstlevel Amount/8,3,SecondLevel Amount/9,3,Allocated_amount/10,3,Release Amount/11,3,Release Mode/12,3,Audit Amount/13,3,Request Date/14,3,Approval Date/15,3,First_level_date/16,3,Second_level_date/17,3,Allocated_date/18,3,Release_date/19,3,Audit_date/20,3,Request_remarks/21,3,Approval_remarks/22,3,First_level_remarks/23,3,Second_level_remarks/24,3,Allocated_remarks/25,3,Release_remarks/26,3,Audit_remarks/27,3,Req_by/28,3,Approved_by/29,3,First_level_b/30,3,Second_level_by/31,3,Allocated_by/32,3,Released_by/33,3,Audit_by/34,3,Status",
        tableRowStartsFrom2: 4, tableColumnStartsFrom2: 0, fileCode2: "BillDep", totalNumberOfColumn2: 35,
        tableContent2: contenall2.substring(0, contenall2.length - 1)
      }
      OperationReportService.AccountExcelwriteDash(details).then((res) => {
        const filename = res.data.message;
        // window.open('http://localhost:8080/ExportFiles/' + filename.toString(), "_blank")
        window.open('http://35.154.221.117:8081/ExportFiles/' + filename.toString(), "_blank");

      })
    })

  }

  useEffect(() => {
    gettotalimportjobs();
    gettotalexportjobs();
    gettotalbilledjobs();
    getamt();

  }, []);
  return (
    <div className=''><Home />
      <Grid className='container' style={{ paddingLeft: "100px" }}>
        <Row style={{ marginBottom: '70px' }}>
          <Row>
            {/* <div className='wish'><span className='wishcss'>{wish} {getUser()}</span></div> */}
            {/* <Typography className='mt-5' style={{ fontFamily: 'Times New Roman', fontWeight: 'bold', fontSize: '25px' }}>Home/Dashboard <span className='wishcss'>{wish} {getUser()}</span></Typography> */}
               <div className='!mx-10 !mt-5 !mb-8 !font-bold !flex items-center gap-96'>

           <div className='!flex items-center gap-2'>
            <div className='!font-semibold !text-lg'>{wish}</div>
            <div className='text-[red] !uppercase !text-lg !font-bold'>{getUser()}</div> 
            </div> 
            <div className='text-xl text-[#56759A]'>HOME / DASHBOARD</div>
              </div>
            <Col className='mt-1'>
              <div className="card cardclr1 mb-3" style={{ height: '9rem' }}>
                <div class="card-body ">
                  <label className='dshHeader'><span style={{ fontSize: '17px' }}>{month}</span> import Jobs</label>
                  <div> <label className='hdrpadding'>{values}</label>
                  </div>
                </div>
                <button class="card-footer cardtitle1" onClick={importjob}>import<span style={{ color: 'white', fontWeight: 'bold' }}>{arrowicon()}</span></button>
              </div>
            </Col>
            <Col className='mt-1'>
              <div className="card mb-3 cardclr2" style={{ height: '9rem' }}>
                <div class="card-body ">
                  <label className='dshHeader'><span style={{ fontSize: '17px' }}>{month}</span> export Jobs</label>
                  <div><label className='hdrpadding'>{values2}</label>
                  </div>
                </div>
                <button class="card-footer cardtitle2" onClick={ExportJob} >export<span style={{ color: 'white', fontWeight: 'bold' }}>{arrowicon()}</span></button>
              </div>
            </Col>
            <Col className='mt-1'>
              <div className="card mb-3 cardclr3" style={{ height: '9rem' }}>
                <div class="card-body ">
                  <label className='dshHeader'><span style={{ fontSize: '17px' }}>{month}</span> billed Jobs</label>
                  <div><label className='hdrpadding'>{values3}</label>
                  </div>
                </div>
                <button class="card-footer cardtitle3">Billing<span style={{ color: 'white', fontWeight: 'bold' }}>{arrowicon()}</span></button>
              </div>
            </Col>
            <Col className='mt-1'>
              <div className="card mb-3 cardclrimg11" style={{ height: '9rem' }}>
                <div class="card-body cardclrimg1">
                </div>
              </div>
            </Col>
          </Row>
          <Row style={{ marginBottom: '14%' }}>
            <Col className='mt-3'>
              <div className="card mb-3 cardclr4" style={{ height: '9rem' }}>
                <div class="card-body ">
                  <label className='dshHeader'>job wise balance Amt</label>
                  <div><label className='hdrpadding'>{amount.totaljobamt}</label></div>
                </div>
                <button class="card-footer cardtitle4" onClick={exceljob}>Excel sheet-job<span>{arrowicon()}</span></button>
              </div>
            </Col>
            <Col className='mt-3'>
              <div className="card mb-3 cardclr5" style={{ height: '9rem' }}>
                <div class="card-body ">
                  <label className='dshHeader'>Misc.wise balance Amt</label>
                  <div><label className='hdrpadding'>{amount.totalmiscamt}</label>
                  </div>
                </div>
                <button class="card-footer cardtitle5" onClick={excelmisc}>Excel sheet-Misc<span>{arrowicon()}</span></button>
              </div>
            </Col>
            <Col className='mt-3'>
              <div className="card mb-3 cardclr6" style={{ height: '9rem' }}>
                <div class="card-body ">
                  <label className='dshHeader'>vendor wise balance Amt</label>
                  <div><label className='hdrpadding'>{amount.totalvendoramt}</label>
                  </div>
                </div>
                <button class="card-footer cardtitle6" onClick={excelvendor}>Excel sheet-Vendor<span>{arrowicon()}</span></button>
              </div>
            </Col>
            <Col className='mt-3'>
              <div className="card mb-3 cardclrimg22" style={{ height: '9rem' }}>
                <div class="card-body cardclrimg2">
                </div>
              </div>
            </Col>
          </Row>
        </Row>
      </Grid >
      {/* <Container>
              <ItemPap elevation={0}>
                <Grid container>
                <Grid item xs={9}>
                <Breadcrumbs aria-label="breadcrumb">

                    <Link
                        underline="hover"
                        color="inherit"
                    >
                        SCOPE-ERP
                    </Link>
                    <Typography color="text.primary">DashBoard</Typography>
                </Breadcrumbs>
                </Grid>
                <Grid item xs={3}>
                <div> </div>
                <div className='wish'><span className='wishcss'>{wish} {getUser()}</span></div>
                </Grid>
                </Grid>
                </ItemPap>
                <ItemPap1>
                <Grid container>
                <Grid item xs={4}>
                <DashPap1 >
                <Box>
                <Grid container>
                <Grid item xs={7}>
                <BiCubeAlt fontSize={30}/>
                </Grid>
                <Grid item xs={5}>
                <span className='wishcss'>Last 10 Days Jobs</span>
                </Grid>
                </Grid>
                <br></br>
                <Grid container>
                <Grid item xs={7}>
                <Grid container>
                <Grid item xs={12}>
                <span>1000</span>
                </Grid>
                <Grid item xs={12}>
                <Link underline="hover" color="inherit" onClick={importjob}>Total Import Job</Link>
                </Grid>
                </Grid>
                </Grid>
                <Grid item xs={5}>
                <LinearProgressWithLabel value={100} />
                </Grid>
                </Grid>
                </Box>
                </DashPap1>
                </Grid>
                <Grid item xs={4}>
                <DashPap1 >
                <Box>
                <Grid container>
                <Grid item xs={7}>
                <BiCubeAlt fontSize={30}/>
                </Grid>
                <Grid item xs={5}>
                <span className='wishcss'>Last 10 Days Jobs</span>
                </Grid>
                </Grid>
                <br></br>
                <Grid container>
                <Grid item xs={7}>
                <Grid container>
                <Grid item xs={12}>
                <span>500</span>
                </Grid>
                <Grid item xs={12}>
                <Link underline="hover" color="inherit" onClick={ExportJob}>Total Export Job</Link>
                </Grid>
                </Grid>
                </Grid>
                <Grid item xs={5}>
                <LinearProgressWithLabel value={50} />
                </Grid>
                </Grid>
                </Box>
                </DashPap1>
                </Grid>
                <Grid item xs={4}>
                <DashPap1 >
                <Box>
                <Grid container>
                <Grid item xs={7}>
                <BiCubeAlt fontSize={30}/>
                </Grid>
                <Grid item xs={5}>
                <span className='wishcss'>Last 10 Days Jobs</span>
                </Grid>
                </Grid>
                <br></br>
                <Grid container>
                <Grid item xs={7}>
                <Grid container>
                <Grid item xs={12}>
                <span>1500</span>
                </Grid>
                <Grid item xs={12}>
                <Link underline="hover" color="inherit" >Total Import&Export Job</Link>
                </Grid>
                </Grid>
                </Grid>
                <Grid item xs={5}>
                <LinearProgressWithLabel value={150} />
                </Grid>
                </Grid>
                </Box>
                </DashPap1>
                </Grid>
                </Grid>
                </ItemPap1>
            </Container> */}

    </div>
  )
}

export default DashBoard